import * as React from 'react';
import { Slider as DesignSlider } from '@whalecloud/fdx';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';

const Slider = ({ element, elementStyle }) => {
  const { formItemSettings, formSettings, settings, className = '' } = element.data;
  const { range, ...rest} = formItemSettings;
  const { visible } = settings;
  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
    >
      <DesignSlider {...rest} className={className} />
    </FormItem>
  );
};

export default Slider;
